import React, { useEffect, useMemo, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import {
  FaClipboardList,
  FaFileAlt,
  FaGraduationCap,
  FaHome,
  FaLayerGroup,
  FaMedal,
  FaSearch,
  FaTrophy,
  FaUserCheck,
  FaUsers,
  FaBookOpen,
  FaCalendarAlt,
  FaBookReader,
  FaBusinessTime,
  FaTasks,
} from "react-icons/fa";
import BackButton from "../ChildComponent/BackButton";
import COLORS from "../resources/colors/COLORS";
import "../css/Admin_css/admin-customize.css";
import "../css/Admin_css/payroll.css";

//Created By Cursor
const HERO_GRADIENT = `linear-gradient(135deg, ${COLORS.primary_color_shade5} 0%, ${COLORS.primary_color_shade7} 55%, ${COLORS.primary_color_shade9} 100%)`;

//Created By Cursor
const ACADEMIC_MODULES = [
  {
    id: "exam",
    title: "Exam",
    hint: "Create and manage exams",
    to: "/AdminMain/ExamList",
    icon: FaClipboardList,
    tone: "exam",
  },
  {
    id: "class-test",
    title: "Class Test",
    hint: "Create and manage class tests",
    to: "/AdminMain/ClassTestList",
    icon: FaTasks,
    tone: "classtest",
  },
  {
    id: "topper",
    title: "Topper List",
    hint: "Class and exam toppers",
    to: "/AdminMain/ExamTopperList",
    icon: FaTrophy,
    tone: "topper",
  },
  {
    id: "assignment",
    title: "Assignment",
    hint: "Coming soon",
    to: null,
    icon: FaBookOpen,
    tone: "assignment",
    disabled: true,
  },
  {
    id: "achievement",
    title: "Achievement",
    hint: "Coming soon",
    to: null,
    icon: FaMedal,
    tone: "achievement",
    disabled: true,
  },
  {
    id: "report-card",
    title: "Report Card",
    hint: "Generate report cards",
    to: "/AdminMain/ExamReportCardList",
    icon: FaFileAlt,
    tone: "report",
  },
  {
    id: "co-education",
    title: "Co-Education",
    hint: "Manage co-education fields",
    to: "/AdminMain/ManageCoEducationField/:exam_id/:session_id/:exam_name/:exam_status",
    icon: FaUsers,
    tone: "coedu",
  },
  {
    id: "social-value",
    title: "Social Value",
    hint: "Manage social value fields",
    to: "/AdminMain/ManageSocialValueField/:exam_id/:session_id/:exam_name/:exam_status",
    icon: FaMedal,
    tone: "social",
  },
  {
    id: "manual-attendance",
    title: "Manual Attendance",
    hint: "Enter attendance manually",
    to: "/AdminMain/ManageManualAttendance",
    icon: FaUserCheck,
    tone: "attendance",
  },
  {
    id: "question-bank",
    title: "Question Bank",
    hint: "Search and add questions",
    to: "/AdminMain/QuestionBank",
    icon: FaBookOpen,
    tone: "bank",
  },
  {
    id: "question-paper",
    title: "Question Paper",
    hint: "View all papers",
    to: "/AdminMain/QuestionPapers",
    icon: FaFileAlt,
    tone: "papers",
  },
  {
    id: "paper-builder",
    title: "Paper Builder",
    hint: "Structure and fill a paper",
    to: "/AdminMain/PaperBuilder",
    icon: FaLayerGroup,
    tone: "builder",
  },
  {
    id: "timetable",
    title: "Timetable Builder",
    hint: "Periods and weekly class grid",
    to: "/AdminMain/TimetableBuilder",
    icon: FaCalendarAlt,
    tone: "timetable",
  },
  //Created By Cursor
  {
    id: "lesson-plan",
    title: "Lesson Plan",
    hint: "Create plans and assign staff tasks",
    to: "/AdminMain/LessonPlan",
    icon: FaBookReader,
    tone: "lessonplan",
  },
  //Created By Cursor
  {
    id: "holidays",
    title: "Holidays",
    hint: "Manage school holidays and festivals",
    to: "/AdminMain/Holiday/MDL007",
    icon: FaCalendarAlt,
    tone: "holidays",
  },
  //Created By Cursor
  {
    id: "school-working-days",
    title: "School Working Day",
    hint: "Monthly working days, week offs and holidays",
    to: "/AdminMain/SchoolWorkingDays",
    icon: FaBusinessTime,
    tone: "workingdays",
  },
];

//Created By Cursor
function AcademicTile({ module, index }) {
  const Icon = module.icon;
  const className = `ac-tile ac-tile--${module.tone}${
    module.disabled ? " is-disabled" : ""
  }`;

  const inner = (
    <>
      <span className={`ac-tile__icon ac-tile__icon--${module.tone}`} aria-hidden>
        {Icon ? <Icon /> : null}
      </span>
      <span className="ac-tile__body">
        <span className="ac-tile__title">{module.title}</span>
        <span className="ac-tile__hint">
          {module.disabled ? "Coming soon" : module.hint}
        </span>
      </span>
    </>
  );

  if (module.disabled || !module.to) {
    return (
      <div
        className={className}
        style={{ "--ac-i": index }}
        aria-disabled="true"
        title={module.hint || "Coming soon"}
      >
        {inner}
      </div>
    );
  }

  return (
    <Link
      to={module.to}
      className={className}
      style={{ "--ac-i": index }}
      aria-label={module.title}
      title={module.hint}
    >
      {inner}
    </Link>
  );
}

//Created By Cursor
function AcademicDashboard() {
  const history = useHistory();
  const [search, setSearch] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const filteredModules = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return ACADEMIC_MODULES;
    return ACADEMIC_MODULES.filter(
      (m) =>
        m.title.toLowerCase().includes(q) ||
        String(m.hint || "")
          .toLowerCase()
          .includes(q)
    );
  }, [search]);

  const activeModules = ACADEMIC_MODULES.filter((m) => !m.disabled).length;

  return (
    <div
      className="content payroll-page sm-page ac-page"
      style={{ background: "#f5f7fb" }}
    >
      <div
        className="content-header d-flex justify-content-between align-items-center"
        style={{ background: COLORS.primary_color_shade6 }}
      >
        <div className="leftside-content-header d-flex align-items-center gap-2">
          <button
            type="button"
            className="qb-home-btn"
            aria-label="Home"
            onClick={() => history.push("/AdminMain")}
          >
            <FaHome />
          </button>
          <ul className="breadcrumbs mb-0">
            <li>
              <span style={{ color: COLORS.white }}>Academic</span>
            </li>
          </ul>
        </div>
        <div className="rightside-content-header">
          <BackButton />
        </div>
      </div>

      <div className="bg_page_white_rounded box_shadow animated fadeInUp sm-shell">
        <header className="sm-hero" style={{ "--sm-hero-bg": HERO_GRADIENT }}>
          <div className="sm-hero__brand">
            <div className="sm-hero__icon" aria-hidden>
              <FaGraduationCap />
            </div>
            <div className="min-w-0">
              <h1 className="sm-hero__title">Academic</h1>
              <p className="sm-hero__sub">
                {activeModules} modules ready · {ACADEMIC_MODULES.length} total
              </p>
            </div>
          </div>
          <div className="sm-hero__tools">
            <label className="ac-hero-search">
              <FaSearch aria-hidden />
              <input
                type="search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search modules…"
                aria-label="Search academic modules"
              />
            </label>
          </div>
        </header>

        <div className="ac-content">
          {filteredModules.length === 0 ? (
            <div className="ac-empty">No modules match “{search.trim()}”.</div>
          ) : (
            <div className="ac-grid">
              {filteredModules.map((module, index) => (
                <AcademicTile key={module.id} module={module} index={index} />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

//Created By Cursor
// Dashboard only — child modules (Exam, Report Card, Holidays, etc.) are
// routed by AdminMain so Links use the app router (no nested BrowserRouter).
const Academic = () => {
  return <AcademicDashboard />;
};

export default Academic;
